import { isRejectedWithValue } from "@reduxjs/toolkit";
import axios from "axios";
import { toast } from "react-toastify";
import { decryptUserId, encryptUserId } from "../utilis/encrypto";
// import BASE_URL from "../common";
import { BASE_URL } from "../constant";
// const base_url = "https://pstgs.appsndevs.com/chatrap";

export function Paymentapi(payload) {
  return new Promise((resolve, reject) => {
    const headers = {
      "Content-Type": "application/json",
    };
    const encryptedUserId = localStorage.getItem("userId");
    const decryptedUserId = decryptUserId(encryptedUserId);

    if (!decryptedUserId) {
      console.error("Failed to decrypt user ID.");
      return reject(new Error("Failed to decrypt user ID."));
    }

    axios
      .post(`${BASE_URL}/transaction/create_checkout_session_web`, payload, {
        headers,
      })
      .then(function (response) {
        // console.log("API Response:", response);
        if (response.data) {
          resolve(response.data);

        } else {
          console.log(response.data);
        }
      })
      .catch(function (error) {
        // console.log("error", error);
        reject(error);
      });
  });
}

export function Billinginfoapi() {
  return new Promise((resolve, reject) => {
    const headers = {
      "Content-Type": "application/json",
    };
    const encryptedUserId = localStorage.getItem("userId");
    const decryptedUserId = decryptUserId(encryptedUserId);

    if (!decryptedUserId) {
      console.error("Failed to decrypt user ID.");
      return reject(new Error("Failed to decrypt user ID."));
    }

    axios
      .get(`${BASE_URL}/transaction/billing_information`)
      .then(function (response) {
        if (response.data.status === "success") {
          // console.log(response.data.message, "asdhfg");
          resolve(response.data);
        } else {
          console.log(response.data);
        }
      })
      .catch(function (error) {
        // console.log("error", error);
        reject(error);
      });
  });
}
export function Transhistoryapi() {
  return new Promise((resolve, reject) => {
    const headers = {
      "Content-Type": "application/json",
    };
    const encryptedUserId = localStorage.getItem("userId");
    const decryptedUserId = decryptUserId(encryptedUserId);

    if (!decryptedUserId) {
      console.error("Failed to decrypt user ID.");
      return reject(new Error("Failed to decrypt user ID."));
    }

    axios
      .get(`${BASE_URL}/transaction/transaction_history/${decryptedUserId}`, {
        headers,
      })
      .then(function (response) {
        if (response.data.status === "success") {
          // console.log(response.data.message, "asdhfg");
          resolve(response.data);
        } else {
          console.log(response.data);
        }
      })
      .catch(function (error) {
        // console.log("error", error);
        reject(error);
      });
  });
}
export function Modelbyapi() {
  return new Promise((resolve, reject) => {
    const headers = {
      "Content-Type": "application/json",
    };
    const encryptedUserId = localStorage.getItem("userId");
    const decryptedUserId = decryptUserId(encryptedUserId);

    if (!decryptedUserId) {
      // console.error("Failed to decrypt user ID.");
      return reject(new Error("Failed to decrypt user ID."));
    }

    axios
      .get(`${BASE_URL}/transaction/by_model/${decryptedUserId}`, { headers })
      .then(function (response) {
        if (response.data.status === "success") {
          // console.log(response.data.message, "asdhfg");
          resolve(response.data);
        } else {
          console.log(response.data);
        }
      })
      .catch(function (error) {
        // console.log("error", error);
        reject(error);
      });
  });
}


const Transactionapiservices = {
  Transhistoryapi,
  Modelbyapi,
  Billinginfoapi,
  Paymentapi,
};

export default Transactionapiservices;
